import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			useErrorBoundary: true,
			retry: false,
			staleTime: Infinity,
		},
	},
});

export default queryClient;
